import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/api/api.service';
import { Listing } from './listing.model';
import { ListingType } from './listing-type.model';
import { ListingPosition } from './listing-position.model';
import { ProfileServiceApiService } from 'src/app/shared/api/profile-service-api.service';
import { PagedResultGeneric } from 'src/app/shared';

@Injectable()
export class ListingService {
  private _apiService: ApiService;

  public constructor(apiService: ApiService, private _profileServiceApiService: ProfileServiceApiService) {
    this._apiService = apiService;
  }

  public search(search?: any): Promise<PagedResultGeneric<Listing>>{
    return this._apiService.get(`Listings`, search);
  }

  public getPrimaryListingCategoryForProfileId(id: number): Promise<string> {
    return this._profileServiceApiService.get(`/profile/v2/${id}/PrimaryListingCategory`);
  }

  public getListingTypes(): Promise<Array<ListingType>> {
    return this._apiService.get(`ListingTypes`).then((data) => {
      return data.Result;
    });
  }

  public getListingPositions(): Promise<Array<ListingPosition>> {
    return this._apiService.get(`ListingPositions`);
  }

  public createListing(listing: Listing): Promise<number> {
    return this._apiService.post(`listings`, listing);
  }

  public updateListing(listing: Listing): Promise<void> {
    return this._apiService.put(`listing/${listing.ListingID}`, listing);
  }

  public deleteListing(id: number): Promise<void> {
    return this._apiService.delete(`listing/${id}`);
  }
}
